module.exports = __webpack_public_path__ + "fonts/c7b5fab.ttf";